import React from 'react';

const FieldCheckboxs = ({ children }) => {
	return <div className="flex flex-wrap gap-5">{children}</div>;
};

export default FieldCheckboxs;
